import React from 'react';
import {
  Button,
  Box,
  Icon,
} from '@chakra-ui/react';
import { FaBoxes } from 'react-icons/fa';

interface SplitOrdersButtonProps {
  count: number;
  onClick?: () => void;
  isDisabled?: boolean;
}

const SplitOrdersButton: React.FC<SplitOrdersButtonProps> = ({
  count,
  onClick,
  isDisabled = false,
}) => {

  return (
    <Box position="relative">
        <Button
          onClick={onClick}
          isDisabled={isDisabled}
          leftIcon={<Icon as={FaBoxes} />}
          size="md"
          backgroundColor="#BBE6E3"
          color="black"
          variant="solid"
          borderRadius="md"
          fontSize="sm"
          fontWeight="normal"
          px={4}
          py={3}
        >
          {count} Confirmed Orders 
        </Button>
      
    </Box>
  );
};

export default SplitOrdersButton; 